<template>
    <div class="page boxBarcodePrint">
        <box fill>
            <el-form label-position="right" label-width="110px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.orderCode" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matCode" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="项次" class="EL-Form-Item">
                        <el-input v-model="mainSearch.lineNo" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="供应商" class="EL-Form-Item">
                        <el-input v-model="mainSearch.supplier" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>

                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.beginTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                 <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="clickSelectList">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="reset">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.endTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="finishPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="clickSelectList">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="reset">重置</el-button>
                    </el-form-item>
                </el-col> -->
            </el-form>
            <el-divider></el-divider>
            <plabel text="箱标签打印列表">
                <el-button v-authority="'BACK_MENU9_M5_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="boxBarcodePrintDialog = true">箱标签打印</el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getBoxAttr" :data="boxMainData.data" pagination :nowPage.sync="boxMainData.nowPage" :pageSize.sync="boxMainData.pageSize" :total.sync="boxMainData.total" @selectionChange="selectAll">
                <el-table-column label="工厂编号" prop="fcCode" align="center">
                </el-table-column>
                <el-table-column label="订单编号" prop="orderCode" align="center">
                </el-table-column>
                <!-- <el-table-column label="订单项次" prop="lineNo" align="center">
                </el-table-column> -->
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="订单数量" prop="orderQuan" align="center">
                </el-table-column>
                <el-table-column label="供应商" prop="supplier" align="center">
                </el-table-column>
                <el-table-column label="每箱数量" prop="standNumber" align="center">
                </el-table-column>
                <el-table-column label="打印标签张数" prop="printNumber" align="center">
                </el-table-column>
                <el-table-column label="单张打印数量" prop="onePrintNumber" align="center">
                </el-table-column>
                <!-- <el-table-column label="累计打印数量" prop="sumPrintNumber" align="center">
                </el-table-column>
                <el-table-column label="未打印数量" prop="notPrintNumber" align="center">
                </el-table-column> -->
                <!-- <el-table-column label="物料二维码" prop="qrCode" align="center">
                </el-table-column> -->
                <el-table-column label="更新时间" prop="updateTime" align="center">
                </el-table-column>
                <el-table-column label="创建时间" prop="createTime" align="center">
                </el-table-column>
                <el-table-column label="操作人" prop="person" align="center">
                </el-table-column>
                <el-table-column label="操作" min-width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU9_M5_B2'" class="btn-t-select" @click="showAuxiStockDetailDialog(scope.row)">详情</el-button>
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 详情 -->
        <el-dialog title="详情" :visible.sync="auxiStockDetailDialog" class="fromDialog" :style="$popups.popups(0.8,0.8)">
            <el-row>
                <el-col :lg="3" :xl="3" :offset="21" style="padding:10px 0">
                    <el-button @click="print()" class="btn-t-edit">打印</el-button>
<!--原代码-->
                  <!--                    <el-button @click="rePrintBarcode()" class="btn-t-edit">打印</el-button>-->


                </el-col>
              <!--打印效果预览-->
              <el-col :lg="3" :xl="3" :offset="21" style="padding:10px 0">
                <el-button @click="printLook()" class="btn-t-edit">预览</el-button>
              </el-col>
            </el-row>

            <h-table :headerCellStyle="boxDetailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.65)" :data="boxDetailData.data" @selectionChange="selectAllDetail">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="箱号" prop="boxCode" align="center">
                </el-table-column>
                <el-table-column label="订单编号" prop="orderCode" align="center">
                </el-table-column>
                <el-table-column label="通道" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column label="规值" prop="specs" align="center">
                </el-table-column>
                <el-table-column label="供应商" prop="supplier" align="center">
                </el-table-column>
                <el-table-column label="图纸版本号" prop="drawCode" align="center">
                </el-table-column>
                <el-table-column label="钢材炉号" prop="rolledSteelCode" align="center">
                </el-table-column>
                <el-table-column label="锻造炉号" prop="forgeCode" align="center">
                </el-table-column>
                <el-table-column label="锻造供应商" prop="forgeSupplierCode" align="center">
                </el-table-column>
                <el-table-column label="热处理号" prop="heatTreatmentCode" align="center">
                </el-table-column>
                <el-table-column label="钢号" prop="steelCode" align="center">
                </el-table-column>
                <el-table-column label="供应商追溯号" prop="supplierRetrospectCode" align="center">
                </el-table-column>
                <el-table-column label="表面处理号" prop="surfaceCode" align="center">
                </el-table-column>
                <el-table-column label="发料日期" prop="storeIssueTime" align="center">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeAuxiStockDetailDialog" type="info" size="mini">关 闭</el-button>
                <!-- <el-button :loading="insertAuxiStockMethods" @click="insertAuxiStockMethod" type="info">收 货</el-button> -->
            </div>
        </el-dialog>


        <!-- 箱标签打印 -->
        <el-dialog title="箱标签打印" :visible.sync="boxBarcodePrintDialog" class="fromDialog" :style="$popups.popups(0.8,0.88)" :close-on-click-modal="false" :show-close="false">
            <el-form label-position="right" label-width="120px" :model="boxPrintData" :rules="boxPrintDataRules" ref="deliveryInData" class="EL-Form">
                <div class="title">订单详情</div>
                <el-col :lg="6" :xl="6">
                    <el-form-item label="订单编号" prop="orderCode" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.orderCode" size="mini" @blur="getOrder(boxPrintData.orderCode)">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="6" :xl="6">
                    <el-form-item label="物料编号" prop="lineNo" class="EL-Form-Item">
                        <el-select v-model="boxPrintData.lineNo" filterable  placeholder="请选择" size="mini" @change="getLineNo(boxPrintData.lineNo)">
                            <el-option v-for="item in lineNoList" :key="item.pdId" :label="item.matCode" :value="item.lineNo">{{item.matCode}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="6" :xl="6">
                    <el-form-item label="工厂编号" prop="matName" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.fcCode" size="mini" disabled>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="6" :xl="6">
                    <el-form-item label="物料描述" prop="matName" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.matName" size="mini" disabled>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="6" :xl="6">
                    <el-form-item label="供应商名称" prop="supplier" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.supplier" size="mini" disabled>
                        </el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="6" :xl="6">
                    <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.matCode" size="mini" disabled>
                        </el-input>
                    </el-form-item>
                </el-col> -->

                <el-col :lg="6" :xl="6">
                    <el-form-item label="订单数量" prop="matQuan" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.matQuan" size="mini" disabled>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="24" :xl="24">
                    <hr style="margin-bottom:1%" />
                </el-col>
                <el-col :lg="24" :xl="24">
                    <div class="title">打印信息</div>
                </el-col>
                <el-col :lg="6" :xl="6">
                    <el-form-item label="每箱数量" prop="matStandNumber" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.matStandNumber" oninput="value=value.replace(/[^\d]/g,'')" size="mini">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="6" :xl="6">
                    <el-form-item label="箱数" prop="printQuan" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.printQuan" oninput="value=value.replace(/[^\d]/g,'')" size="mini">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="6" :xl="6">
                    <el-form-item label="单张打印数量" prop="onePrintQuan" class="EL-Form-Item">
                        <el-select v-model="boxPrintData.onePrintQuan" placeholder="请选择" size="mini" >
                            <el-option key="1" label="1" value="1"></el-option>
                            <el-option key="2" label="2" value="2"></el-option>
                            <el-option key="3" label="3" value="3"></el-option>
                            <el-option key="4" label="4" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="6" :xl="6" >
                    <el-form-item label="累计打印数量" prop="numPrintQuan" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.numPrintQuan" size="mini" disabled>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="6" :xl="6">
                    <el-form-item label="未打印数量" prop="noPrintQuan" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.noPrintQuan" size="mini" disabled>
                        </el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="24" :xl="24">
                    <hr style="margin-bottom:1%" />
                </el-col>
                <el-col :lg="24" :xl="24">
                    <div class="title">箱标签信息</div>
                </el-col>
                <!-- <div v-for="(item,index) in labelAttrList" :key="index">
                    <el-col :lg="6" :xl="6">
                        <el-form-item :label="item.labelName+''" prop="labelAttr">
                            <div v-for="(ele,i) in  boxPrintData.labelAttr" :key="i">
                                <el-input v-model="ele[index].value" :value="ele[i]" size="mini">
                                </el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                </div> -->
                <div v-for="(item,index) in boxPrintData.labelAttr" :key="index">
                    <el-col :lg="6" :xl="6">
                        <el-form-item :label="item.labelName+''" prop="labelAttr">
                            <el-input v-model="item.value" maxlength="20" :value="item[index]" size="mini">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </div>
                <el-col :lg="24" :xl="24">
                    <hr style="margin-bottom:1%" />
                </el-col>
                <!-- <el-col :lg="24" :xl="24">
                    <div class="title">外协条码录入</div>
                </el-col>
                <el-col :lg="6" :xl="6">
                    <el-form-item label="物料二维码" prop="matCodeQR" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.matCodeQR" size="mini">
                        </el-input>
                    </el-form-item>
                </el-col> -->
            </el-form>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="colsePrint" type="info" size="mini">关 闭</el-button>
                <el-button @click="boxPrintBarcode" class="btn-t-edit" type="primary" size="mini">保存并打印</el-button>
<!--                <el-button @click="savePrint" class="btn-t-edit" type="primary" size="mini">保存并打印</el-button>-->
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getLodop } from '../../libs/LodopFuncs.js'
    import moment from "moment";
    export default {
        name: "BoxBarcodePrint",
        data() {
            return {
                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                // 筛选条件
                mainSearch: {
                    orderCode: '',
                    lineNo: '',
                    supplier: '',
                    matCode: '',
                    endTime:"",
                    beginTime:""
                },

                //全选
                checkList: [],
                //采购窗口
                insertAuxiStockDialog: false,
                //间材库入库详情窗口
                auxiStockDetailDialog: false,

                //箱标签打印
                boxBarcodePrintDialog: false,

                //阻盘明细对象集合
                auxiStockDetailData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //详情多选
                checkDetailList: [],
                // 工厂编号
                fcCode: localStorage.getItem("fcCode") || "",
                //操作人
                person: localStorage.getItem("user"),
                //操作人工号
                personNumber: localStorage.getItem("empNumber"),

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注

                orderCode: '', //订单编号

                mtTypeList: [],

                //箱体打印信息
                barcodePrintData: {},


                downloadLoading: false, //下载中
                insertAuxiStockMethods: false,

                //箱标签打印
                boxPrintData: {
                    orderCode: '',
                    lineNo: '',
                    supplier: '',
                    matCode: '',
                    matName: '',
                    matQuan: '',
                    matStandNumber: 0, //每箱箱数
                    printQuan: 0,
                    onePrintQuan: 1,
                    numPrintQuan: '',
                    noPrintQuan: '',
                    labelAttr: [],
                    matCodeQR: '',
                    surplusQuan: '剩余数量',
                },
                lineNoList: [],
                orderPurchaseList: [],
                labelAttrList: [],

                labelAttr11111: {
                    labelName: "",
                    value: "",
                },

                boxAttrData: [],
                boxMainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },

                boxDetailData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },

                boxPrintDataRules: {
                    orderCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    lineNo: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                    matStandNumber: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    printQuan: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    onePrintQuan: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    labelAttr: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },

                //打印
                lazyNext: null,
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            mainSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getBoxAttr(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        computed: {
           startPickerOptions() {
            let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.beginTime) {
                            return time.getTime() > new Date(_this.mainSearch.beginTime);
                        }
                    },
                };
            },
            finishPickerOptions() {
                let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.endTime) {
                            return time.getTime() < new Date(_this.mainSearch.endTime);
                        }
                    },
                };
            },
        },
        methods: {
            BlurText(e) {
                let boolean = new RegExp("^[1-9][0-9]*$").test(e.target.value);
                if (!boolean) {
                    this.$message.warning("请输入正整数");
                    e.target.value = "";
                };
            },

            //复选框
          selectAll(val) {
           this.checkList = val;
          },
          //箱标签打印
          boxPrintBarcode(){
            if (this.boxPrintData.matStandNumber == 0 || this.boxPrintData.matStandNumber == undefined) {
              this.$message({
                message: '请输入每箱箱数！',
                type: 'warning'
              });
              return;
            }
            if (this.boxPrintData.printQuan == 0 || this.boxPrintData.printQuan == undefined) {
              this.$message({
                message: '请输入打印标签张数！',
                type: 'warning'
              });
              return;
            }
            if (this.boxPrintData.onePrintQuan == 0 || this.boxPrintData.onePrintQuan == undefined) {
              this.$message({
                message: '请输入单张打印数量！',
                type: 'warning'
              });
              return;
            };

            if(this.boxPrintData.matStandNumber * this.boxPrintData.printQuan > this.boxPrintData.matQuan){
              this.$message({
                message: '打印数量超过计划数量',
                type: 'warning'
              });
              return;
            }

            for (let i in this.boxPrintData.labelAttr) {
              if (this.boxPrintData.labelAttr[i].value == "") {
                this.$message({
                  message: this.boxPrintData.labelAttr[i].labelName + '不能为空！',
                  type: 'warning'
                });
                return;
              }

            }

            this.checkDetailList = [];

            if (this.submitForm("deliveryInData")) {
              // console.log("boxPrintData", this.boxPrintData)
              this.$http
                  .request({
                    url: "/api/boxPrint/insertBoxPrint",
                    method: "POST",
                    showLoading: true,
                    data: this.boxPrintData,
                    params: {
                      person: localStorage.getItem("user")
                    }
                  })
                  .then((resp) => {
                    if (resp.status == 100) {
                      this.$notify({
                        title: "成功",
                        message: "新增成功！",
                        type: "success",
                      });
                      this.logRemarks = "boxPrint箱标签打印新增成功";
                      this.editBoxShow = false;
                      this.getBoxAttr();

                      for(var index in resp.data){

                        var i = 0;
                        while (i < this.boxPrintData.onePrintQuan){
                            this.checkDetailList.push(resp.data[index]);
                            i ++;
                        }

                      }
                      

                      console.log(this.checkDetailList);
                      let LODOP = this.printInit(this.checkDetailList);
                      //打印
                      LODOP.PRINT();

                    } else {
                      this.$notify.error({
                        title: "失败",
                        message: resp.message,
                      });
                      this.logRemarks = "boxPrint箱标签打印新增失败";
                    }
                    // this.logContent =
                    // this.systemLog();
                    //this.colsePrint();
                  })
                  .catch((error) => {
                    this.$notify.error({
                      title: "失败",
                      message: "调用失败",
                    });
                  });
            }

          },
          //直接打印
          print(){
            if (this.checkDetailList.length == 0) {
              this.$message({
                message: "请勾选打印单！",
                type: "warning",
              });
              return;
            }
            //无码时添加打印限制
            if (this.lazyNext) {
              this.$message.error('请五秒后再打印！')
              return
            } else {
              console.log(this.checkDetailList);
              let LODOP = this.printInit(this.checkDetailList);
              //预览
              LODOP.PRINT();
            }
          },
          //预览
          printLook(){
            if (this.checkDetailList.length == 0) {
              this.$message({
                message: "请勾选打印单！",
                type: "warning",
              });
              return;
            }
            //无码时添加打印限制
            if (this.lazyNext) {
              this.$message.error('请五秒后再打印！')
              return
            } else {
              console.log("选中数据:",this.checkDetailList);
              let LODOP = this.printInit(this.checkDetailList);
              //预览
              LODOP.PREVIEW();
            }
          },
          //设置打印参数
          printInit(data){
            let barCodePrintInfo = this.barcodePrintData;
            let toAddress = "";
            let fcCode = "";
            if(this.barcodePrintData.fcCode != undefined){
                 toAddress = barCodePrintInfo.fcCode=='DLM'?'铁山东三路53号':'淮河中路87号';
                 fcCode = barCodePrintInfo.fcCode;
            }else{
                 toAddress = this.lineNoList[0].fcCode =='DLM'?'铁山东三路53号':'淮河中路87号';
                 fcCode = this.lineNoList[0].fcCode;
            }
            let printTime = moment().format("YYYY-MM-DD HH:mm:ss");
            let printList  =data.map(item =>{
              var produceTime = moment(item.matProduceTime).format("YYYYMMDD");
              var qrCode = item.boxCode + "," + barCodePrintInfo.orderCode + "," + barCodePrintInfo.whCode + "," +
                  barCodePrintInfo.matCode + "," + item.matQuan + "," + item.specs +
                  "," + item.orderCode + "," + produceTime + "," + item.boxHeight + "," +
                  item.steelCode + "," + item.rolledSteelCode + "," + item.forgeCode;
                qrCode = qrCode.replaceAll("undefined","");
                
              return {
                gyName:item.supplier,
                //送货地址
                toAddress:"斯凯孚大连轴承与精密技术有限公司",
                address:toAddress,
                //物料型号
                wlType:item.matCode,
                //批次
                pc:item.specs,
                //追溯
                zs:item.supplierRetrospectCode,
                //订单好
                orderNo: item.orderCode,
                //发料日期
                flDate:moment(item.store_issue_time).format("YYYYMMDD"),
                //通道
                td:item.whCode,
                //图纸号
                imgNo:item.drawCode,
                //数量
                num:item.matQuan,
                //钢材炉号
                gcLN:item.rolledSteelCode,
                //钢号
                gcNo:item.steelCode,
                //热处理号
                rcNo:item.heatTreatmentCode,
                //表面处理号
                bmcNo:item.surfaceCode,
                //锻造供应商
                dzGY:item.forgeSupplierCode,
                //锻造炉号
                dzNo:item.forgeCode,
                //打印日期
                dyDate:printTime,
                //二维码
                qrCode:qrCode,
                //包装箱号
                boxBarcode:item.boxCode,
                //工厂
                //fcCode: barCodePrintInfo.fcCode
                fcCode: fcCode,
              }
            })
            console.log("打印信息:",printList);
            let LODOP = getLodop();
            LODOP.PRINT_INIT("标签打印");
            printList.forEach((item)=>{
              //强制分页
              LODOP.NEWPAGE();
              //设置打印样式
              this.setPrintSty(LODOP,item);
            })
            return LODOP;
          },
          //设置打印格式
          setPrintSty(LODOP,param){
            //设置纸张大小
            // LODOP.PRINT_INITA(0,0,1380,1050,"箱标签打印")
            LODOP.SET_PRINT_PAGESIZE(2,"105mm","138mm","");

            //设置标题行属性
            LODOP.ADD_PRINT_RECT("1mm","1mm","136mm","8mm",0, 1)//边框
            LODOP.ADD_PRINT_TEXTA("title","2mm","1mm","136mm","8mm","STOCK LABEL SKF DL")
            LODOP.SET_PRINT_STYLEA("title","FontSize", 18);
            LODOP.SET_PRINT_STYLEA("title","Alignment", 2);
            //供应商名称标题
            LODOP.ADD_PRINT_RECT("9mm","1mm","68mm","8mm",0, 1)//边框
            LODOP.ADD_PRINT_TEXTA("gyName","11mm","1mm","68mm","8mm"," From 供应商名称:")
            LODOP.SET_PRINT_STYLEA("gyName","FontSize", 14);
            LODOP.SET_PRINT_STYLEA("gyName","Alignment", 1);
            // //送货地点标题
            LODOP.ADD_PRINT_RECT("9mm","69mm","68mm","8mm",0, 1)//边框
            LODOP.ADD_PRINT_TEXTA("toAddress","11mm","69mm","68mm","8mm",param.fcCode == 'DLM'?" To 送货地点:(MSB)":" To 送货地点:(LSB)")
            LODOP.SET_PRINT_STYLEA("toAddress","FontSize", 14);
            LODOP.SET_PRINT_STYLEA("toAddress","Alignment", 1);
            //供应商名称value
            LODOP.ADD_PRINT_RECT("17mm","1mm","68mm","16mm",0, 1)//边框
            LODOP.ADD_PRINT_TEXTA("gyValue","20mm","3mm","68mm","16mm",param.gyName)
            LODOP.SET_PRINT_STYLEA("gyValue","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("gyValue","Alignment", 1);
            //送货地点value
            LODOP.ADD_PRINT_RECT("17mm","69mm","68mm","16mm",0, 1)//边框
            LODOP.ADD_PRINT_TEXTA("toAValue","20mm","70mm","72mm","8mm",param.toAddress)
            LODOP.SET_PRINT_STYLEA("toAValue","FontSize", 11);
            LODOP.SET_PRINT_STYLEA("toAValue","Alignment", 2);
            LODOP.ADD_PRINT_TEXTA("toAValue","28mm","70mm","72mm","8mm",param.address)
            LODOP.SET_PRINT_STYLEA("toAValue","FontSize", 11);
            LODOP.SET_PRINT_STYLEA("toAValue","Alignment", 1);

            //设置二维码 QRCode指定二维码格式
            LODOP.ADD_PRINT_RECT("33mm","1mm","45mm","56mm",0, 1)//边框
            LODOP.ADD_PRINT_BARCODE("40mm","4mm","44mm","46mm", "QRCode", param.qrCode);
            //物料型号设置
            LODOP.ADD_PRINT_RECT("33mm","46mm","91mm","8mm",0, 1)//边框
            LODOP.ADD_PRINT_TEXTA("wlType","35mm","48mm","23mm","8mm","物料型号:");//标题
            LODOP.SET_PRINT_STYLEA("wlType","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("wlType","Alignment", 1);
            LODOP.ADD_PRINT_TEXTA("wlTAValue","35mm","71mm","68mm","8mm",param.wlType);//值
            LODOP.SET_PRINT_STYLEA("wlTAValue","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("wlTAValue","Alignment", 1);
            LODOP.SET_PRINT_STYLEA("wlTAValue","Bold", 1);

            //订单信息框
            LODOP.ADD_PRINT_RECT("41mm","46mm","45mm","32mm",0, 1)//边框
            LODOP.ADD_PRINT_TEXTA("orderNo","42mm","48mm","45mm","8mm","订单号:"+param.orderNo);//标题+值
            LODOP.SET_PRINT_STYLEA("orderNo","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("orderNo","Alignment", 1);
            if (param.pc != undefined && param.pc!=''){
              LODOP.ADD_PRINT_TEXTA("pc","49mm","48mm","45mm","8mm","批次/规值:"+param.pc);//标题+值
            }else {
              LODOP.ADD_PRINT_TEXTA("pc","49mm","48mm","45mm","8mm","批次/规值:");//标题+值
            }
            LODOP.SET_PRINT_STYLEA("pc","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("pc","Alignment", 1);
            LODOP.ADD_PRINT_TEXTA("td","56mm","48mm","45mm","8mm","通道:"+param.td);//标题+值
            LODOP.SET_PRINT_STYLEA("td","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("td","Alignment", 1);
            LODOP.ADD_PRINT_TEXTA("num","63mm","48mm","15mm","8mm","数量:");//标题+值
            LODOP.SET_PRINT_STYLEA("num","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("num","Alignment", 1);
            LODOP.SET_PRINT_STYLEA("numValue","Bold", 1);
            LODOP.ADD_PRINT_TEXTA("numValue","63mm","58mm","25mm","8mm",param.num);//标题+值
            LODOP.SET_PRINT_STYLEA("numValue","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("numValue","Alignment", 1);
            LODOP.SET_PRINT_STYLEA("numValue","Bold", 1);

            //发料信息边框
            LODOP.ADD_PRINT_RECT("41mm","91mm","46mm","32mm",0, 1)//边框
            LODOP.ADD_PRINT_TEXTA("flDate","42mm","93mm","45mm","8mm","发料日期:"+param.flDate);//标题+值
            LODOP.SET_PRINT_STYLEA("flDate","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("flDate","Alignment", 1);
            if (param.zs != undefined && param.zs!=''){
              LODOP.ADD_PRINT_TEXTA("zs","49mm","93mm","45mm","8mm","追溯:"+param.zs);//标题+值
              LODOP.SET_PRINT_STYLEA("zs","FontSize", 12);
              LODOP.SET_PRINT_STYLEA("zs","Alignment", 1);
            }
            LODOP.ADD_PRINT_TEXTA("imgNo","56mm","93mm","45mm","8mm","图纸号:"+param.imgNo);//标题+值
            LODOP.SET_PRINT_STYLEA("imgNo","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("imgNo","Alignment", 1);
            //打印时间
            LODOP.ADD_PRINT_RECT("89mm","1mm","45mm","16mm",0, 1)//边框
            LODOP.ADD_PRINT_TEXTA("bqdyDate","90mm","1","45mm","8mm","标签打印时间");//标题
            LODOP.SET_PRINT_STYLEA("bqdyDate","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("bqdyDate","Alignment", 2);
            // LODOP.ADD_PRINT_RECT("97mm","1mm","45mm","8mm",0, 1)//边框
            LODOP.ADD_PRINT_TEXTA("bqdyValue","98mm","1","45mm","8mm",param.dyDate);//值
            LODOP.SET_PRINT_STYLEA("bqdyValue","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("bqdyValue","Alignment", 2);

            //加工信息
            LODOP.ADD_PRINT_RECT("73mm","46mm","91mm","32mm",0, 1)//边框
            //动态加载
            LODOP.ADD_PRINT_TEXTA("boxBarcode","74mm","48mm","25mm","8mm","包装箱号:");//标题
            LODOP.SET_PRINT_STYLEA("boxBarcode","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("boxBarcode","Alignment", 1);
            LODOP.ADD_PRINT_TEXTA("boxBarcodeValue","74mm","73mm","60mm","8mm",param.boxBarcode);//值
            LODOP.SET_PRINT_STYLEA("boxBarcodeValue","FontSize", 12);
            LODOP.SET_PRINT_STYLEA("boxBarcodeValue","Alignment", 1);
            LODOP.SET_PRINT_STYLEA("boxBarcodeValue","Bold", 1);
            let i = 0;
            if (param.gcLN != undefined && param.gcLN!=''){
              i++;
              let changeParam = "钢材炉号:"+param.gcLN;
              this.changePrintSty(i,changeParam,LODOP);
            }
            if (param.gcNo != undefined && param.gcNo!=''){
              i++;
              let changeParam = "钢号:"+param.gcNo;
              this.changePrintSty(i,changeParam,LODOP);
            }
            if (param.bmcNo != undefined && param.bmcNo!=''){
              i++;
              let changeParam = "表面处理号:"+param.bmcNo;
              this.changePrintSty(i,changeParam,LODOP);
            }
            if (param.rcNo != undefined && param.rcNo!=''){
              i++;
              let changeParam = "热处理号:"+param.rcNo;
              this.changePrintSty(i,changeParam,LODOP);
            }
            if (param.dzGY != undefined && param.dzGY!=''){
              i++;
              let changeParam = "锻造供应商:"+param.dzGY;
              this.changePrintSty(i,changeParam,LODOP);
            }
            if (param.dzNo != undefined && param.dzNo!=''){
              i++;
              let changeParam = "锻造炉号:"+param.dzNo;
              this.changePrintSty(i,changeParam,LODOP);
            }
            return LODOP;
          },
          //打印动态设置
          changePrintSty(i,param,LODOP){
            console.log("动态加载index:",i);
            //有于是为单数 设置第一个行元素
            let index = parseInt(i/2);
            if (i%2>0){
              let height = 82+index*8 +'mm';
              LODOP.ADD_PRINT_TEXTA("changeSty_"+i,height,"48mm","45mm","8mm",param);//标题+值
            }else {
              index--;
              let height = 82+index*8 +'mm';
              LODOP.ADD_PRINT_TEXTA("changeSty_"+i,height,"93mm","45mm","8mm",param);//标题+值
            }
            LODOP.SET_PRINT_STYLEA("changeSty_"+i,"FontSize", 12);
            LODOP.SET_PRINT_STYLEA("changeSty_"+i,"Alignment", 1);
          },
            /**
             * 多选
             */
            selectAllDetail(val) {
                this.checkDetailList = val;
                // console.log("=============", val);
            },


            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.clickSelectList()
                }, 1000)
            },

            //打开间材库入库明细窗口
            showAuxiStockDetailDialog(data) {
                this.auxiStockDetailDialog = true;
                this.getBoxDetails(data.printId);
                this.barcodePrintData = data;
            },
            //关闭间材库明细窗口
            closeAuxiStockDetailDialog() {
                this.auxiStockDetailData.data = [];
                this.auxiStockDetailDialog = false;
            },

            // 点击查询按钮 重置页号
            clickSelectList(newVal) {
                this.getBoxAttr(newVal);
            },
            /**
             * 获取箱标签记录
             */
            getBoxAttr() {
                this.$http
                    .request({
                        url: "/api/boxPrint/getBoxPrintAll",
                        method: "GET",
                        params: {
                            pageNum: this.boxMainData.nowPage, // 页号
                            pageSize: this.boxMainData.pageSize, // 页大小
                            orderCode: this.mainSearch.orderCode || null,
                            lineNo: this.mainSearch.lineNo || null,
                            supplier: this.mainSearch.supplier || null,
                            matCode: this.mainSearch.matCode || null,
                            person: localStorage.getItem("user"),
                            beginTime: this.mainSearch.beginTime || null,
                            endTime: this.mainSearch.endTime || null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.boxMainData.data = res.data.list;
                            this.boxMainData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            /**
             * 获取箱标签记录详情
             */
            getBoxDetails(printId) {
                this.$http
                    .request({
                        url: "/api/boxPrint/getBoxAtter",
                        method: "GET",
                        params: {
                            printId: printId || null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.boxDetailData.data = res.data.list;
                            this.boxDetailData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },


            /**
             * 获取间材库入库记录
             */
            getAuxiStockData() {
                this.$http
                    .request({
                        url: "/api/order/getOrderPurchaseList",
                        method: "GET",
                        params: {
                            pageNum: this.mainData.nowPage, //	页号
                            pageSize: this.mainData.pageSize, //	页大小
                            fcCode: this.mainSearch.fcCode || null, //	工厂编号
                            sasCode: this.mainSearch.sasCode || null, //	间材库入库编号
                            matCode: this.mainSearch.matCode || null, //	物料编号
                            matName: this.mainSearch.matName || null, // 物料描述
                            status: this.mainSearch.status || null, //	状态
                            // person: this.mainSearch.person || null, //操作员
                            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                            //whCode: this.mainSearch.whCode || null,
                            orderCode: this.mainSearch.orderCode,
                            wareType: '20'
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.mainData.data = res.data.list;
                            this.mainData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            /**
             * 根据间材库入库编号查询详情
             */
            getAuxiStockDetail() {
                //根据间材库入库编号获取详细信息
                this.$http
                    .request({
                        url: "/api/order/getOrderPurchaseDetailList",
                        method: "GET",
                        params: {
                            orderCode: this.orderCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.auxiStockDetailData.data = resp.data.list;
                            for (var index in this.auxiStockDetailData.data) {
                                this.auxiStockDetailData.data[index].nowQuan = 0;
                                this.auxiStockDetailData.data[index].person = this.person;
                                this.auxiStockDetailData.data[index].personNumber = this.personNumber;
                                this.auxiStockDetailData.data[index].fcCode = this.fcCode;
                            }
                            this.auxiStockDetailData.total = resp.data.total;
                        }

                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            //获取数据
            getOrderDetail(orderCode) {
                this.$http
                    .request({
                        url: "/api/order/getOrderPurchaseDetailList",
                        method: "GET",
                        params: {
                            orderCode: orderCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.lineNoList = resp.data.list
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            getOrder(orderCode) {
                this.$http
                    .request({
                        url: "/api/order/getOrderPurchaseList",
                        method: "GET",
                        params: {
                            orderCode: orderCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.list == null) {
                                this.$message({
                                    message: '记录未找到',
                                    type: 'warning'
                                });
                                return;
                            }
                            this.orderPurchaseList = resp.data.list;
                            this.getOrderDetail(orderCode);
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            colsePrint() {
                this.boxBarcodePrintDialog = false;
                this.boxPrintData = {
                    orderCode: '',
                    lineNo: '',
                    supplier: '',
                    matCode: '',
                    matName: '',
                    matQuan: '',
                    matStandNumber: 0, //每箱箱数
                    printQuan: 0,
                    onePrintQuan: 1,
                    numPrintQuan: '',
                    noPrintQuan: '',
                    labelAttr: [],
                    matCodeQR: '',
                };
                this.lineNoList = []
                this.labelAttr = []
                this.labelAttr11111 = []
            },
            getLineNo(lineNo) {
                let orderInfo = this.lineNoList.find(o => o.lineNo == lineNo);
                this.boxPrintData.matCode = orderInfo.matCode;
                this.boxPrintData.matName = orderInfo.matName;
                this.boxPrintData.matQuan = orderInfo.orderQuan - orderInfo.matArriveQuan;
                this.boxPrintData.supplier = this.orderPurchaseList[0].supplier
                this.boxPrintData.whCode = orderInfo.whCode;
                this.boxPrintData.fcCode = orderInfo.fcCode;
                this.$http
                    .request({
                        url: "/api/vendorLabel/getMatLabel",
                        method: "GET",
                        params: {
                            matCode: this.boxPrintData.matCode,
                            vendorCode: this.boxPrintData.supplier,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.labelAttrList = resp.data.list

                            this.labelAttrList.forEach((item) => {
                                this.labelAttr11111 = {
                                    labelName: item.labelName,
                                    value: "",
                                    labelCode: item.labelCode,
                                }
                                this.boxPrintData.labelAttr.push(this.labelAttr11111)
                            })
                        } else {
                            this.$message({
                                message: resp.message,
                                type: 'warning'
                            });
                            return;
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });

            },
            savePrint() {
                if (this.boxPrintData.matStandNumber == 0 || this.boxPrintData.matStandNumber == undefined) {
                    this.$message({
                        message: '请输入每箱箱数！',
                        type: 'warning'
                    });
                    return;
                }
                if (this.boxPrintData.printQuan == 0 || this.boxPrintData.printQuan == undefined) {
                    this.$message({
                        message: '请输入打印标签张数！',
                        type: 'warning'
                    });
                    return;
                }
                if (this.boxPrintData.onePrintQuan == 0 || this.boxPrintData.onePrintQuan == undefined) {
                    this.$message({
                        message: '请输入单张打印数量！',
                        type: 'warning'
                    });
                    return;
                };

                if(this.boxPrintData.matStandNumber * this.boxPrintData.printQuan > this.boxPrintData.matQuan){
                    this.$message({
                        message: '打印数量超过计划数量',
                        type: 'warning'
                    });
                    return;
                }

                for (let i in this.boxPrintData.labelAttr) {
                    if (this.boxPrintData.labelAttr[i].value == "") {
                        this.$message({
                            message: this.boxPrintData.labelAttr[i].labelName + '不能为空！',
                            type: 'warning'
                        });
                        return;
                    }

                }

                if (this.submitForm("deliveryInData")) {
                    // console.log("boxPrintData", this.boxPrintData)
                    this.$http
                        .request({
                            url: "/api/boxPrint/insertBoxPrint",
                            method: "POST",
                            showLoading: true,
                            data: this.boxPrintData,
                            params: {
                                person: localStorage.getItem("user")
                            }
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "boxPrint箱标签打印新增成功";
                                this.editBoxShow = false;
                                this.getBoxAttr();

                                this.checkDetailList = resp.data;

                                console.log(this.checkDetailList);

                                var barCodePrintInfo = this.boxPrintData;

                                this.checkDetailList.forEach((item) => {

                                    var produceTime = moment(item.matProduceTime).format("YYYYMMDD");

                                    //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                    // var qrCode = "T/" + barCodePrintInfo.orderCode + "/" + item.boxCode + "/" + barCodePrintInfo.matCode + "/" +
                                    //     item.matQuan + "/" + barCodePrintInfo.matSpecs + "/" + item.newBatchNo +
                                    //     "/" + produceTime + "/" + item.boxHeight + "/";

                                    //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                    var qrCode = item.boxCode + "," + barCodePrintInfo.orderCode + "," + barCodePrintInfo.whCode + "," +
                                        barCodePrintInfo.matCode + "," + item.matQuan + "," + item.specs +
                                        "," + item.orderCode + "," + produceTime + "," + item.boxHeight + "," + item.steelCode + "," + item.rolledSteelCode + "," + item.forgeCode;

                                    if (item.specs == undefined) {
                                        item.specs = "";
                                    }

                                    var pritnTwo = false;
                                    if (barCodePrintInfo.onePrintQuan > 1) {
                                        pritnTwo = true;
                                    }

                                    var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                    var barcodeData = {
                                        boxBarcode: item.boxCode,
                                        prodCode: barCodePrintInfo.matCode,
                                        prodName: barCodePrintInfo.matName,
                                        batchNo: barCodePrintInfo.orderCode,
                                        count: item.matQuan,
                                        checkPerson: localStorage.getItem("empNumber"),
                                        date: produceTime,
                                        poCode: barCodePrintInfo.orderCode,
                                        matSpecs: item.specs,
                                        whCode: barCodePrintInfo.whCode,
                                        qrCode: qrCode,
                                        supply: barCodePrintInfo.supplier,
                                        printTime: printTime,
                                        steel_code: item.steelCode,
                                        draw_code: item.drawCode,
                                        rolled_steel_code: item.rolledSteelCode,
                                        forge_code: item.forgeCode,
                                        forge_supplier_code: item.forgeSupplierCode,
                                        heat_treatment_code: item.heatTreatmentCode,
                                        surface_code: item.surfaceCode,
                                        supplier_retrospect_code: item.supplierRetrospectCode,
                                        printTwo: false,
                                        printCount:barCodePrintInfo.onePrintQuan,
                                        supplyName: localStorage.getItem("userName"),
                                        // fcAddress: localStorage.getItem("fcCode")=='DLM'?'铁山东三路53号':'淮河中路87号',
										fcAddress: barCodePrintInfo.fcCode=='DLM'?'铁山东三路53号':'淮河中路87号',
                                        fcName: "斯凯孚大连轴承与精密技术有限公司"
                                    }

                                    this.$printer.printWMSSupplyBarcode(barcodeData);
                                })

                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "boxPrint箱标签打印新增失败";
                            }
                            // this.logContent =
                            // this.systemLog();
                            this.colsePrint();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }

            },
            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },

            /**
             * 重置
             */
            reset() {
                this.mainSearch = {
                    orderCode: '',
                    lineNo: '',
                    supplier: '',
                    matCode: '',
                    requireDate: []
                };
                this.getBoxAttr();
            },


            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "箱标签打印",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("userName") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },

            //标签打印
            rePrintBarcode() {
                if (this.checkDetailList.length == 0) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }
                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {

                    var barCodePrintInfo = this.barcodePrintData;

                    console.log(this.checkDetailList);

                    this.checkDetailList.forEach((item) => {

                        var produceTime = moment(item.matProduceTime).format("YYYYMMDD");

                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                        // var qrCode = "T/" + barCodePrintInfo.orderCode + "/" + item.boxCode + "/" + barCodePrintInfo.matCode + "/" +
                        //     item.matQuan + "/" + barCodePrintInfo.matSpecs + "/" + item.newBatchNo +
                        //     "/" + produceTime + "/" + item.boxHeight + "/";

                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        var qrCode = item.boxCode + "," + item.orderCode + "," + barCodePrintInfo.whCode + "," +
                            barCodePrintInfo.matCode + "," + item.matQuan + "," + item.specs +
                            "," + item.newBatchNo + "," + produceTime + "," + item.boxHeight  + "," + item.steelCode + "," + item.rolledSteelCode + "," + item.forgeCode;

                        if (item.specs == undefined) {
                            item.specs = "";
                        }

                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        var barcodeData = {
                            boxBarcode: item.boxCode,
                            prodCode: barCodePrintInfo.matCode,
                            prodName: barCodePrintInfo.matName,
                            batchNo: item.newBatchNo,
                            count: item.matQuan,
                            checkPerson: localStorage.getItem("empNumber"),
                            date: produceTime,
                            poCode: barCodePrintInfo.orderCode,
                            matSpecs: item.specs,
                            whCode: barCodePrintInfo.whCode,
                            qrCode: qrCode,
                            supply: barCodePrintInfo.supplier,
                            printTime: printTime,
                            printTwo: item.printTwo,
                            steel_code: item.steelCode,
                            draw_code: item.drawCode,
                            rolled_steel_code: item.rolledSteelCode,
                            forge_code: item.forgeCode,
                            forge_supplier_code: item.forgeSupplierCode,
                            heat_treatment_code: item.heatTreatmentCode,
                            surface_code: item.surfaceCode,
                            supplier_retrospect_code: item.supplierRetrospectCode,
                            supplyName: localStorage.getItem("userName"),
                            // fcAddress: localStorage.getItem("fcCode")=='DLM'?'铁山东三路53号':'淮河中路87号',
							fcAddress: barCodePrintInfo.fcCode=='DLM'?'铁山东三路53号':'淮河中路87号',
                            fcName: "斯凯孚大连轴承与精密技术有限公司"
                        }

                        // console.log(barcodeData);

                        this.$printer.printWMSSupplyBarcode(barcodeData);
                    })

                    this.lazyNext = setTimeout(() => {
                        this.lazyNext = null
                    }, 5000)
                }
            },
        },
        activated(){
            /* 获取首页的数据 */
            this.getBoxAttr();
        },
    };
</script>

<style lang="scss" scoped>
    .div {
        border: 1px solid black;
        width: 90%;
        height: 140px;
        margin-top: 30px;
        border-radius: 10px;
        margin-left: 48px;
        text-align: left;
    }

    /* .div {
        border: 1px solid black;
        width: 90%;
        height: 140px;
        margin-top: 30px;
        border-radius: 10px;
        margin-left: 48px;
        text-align: left;
    }

    .div1 {
        border: 1px solid black;
        width: 90%;
        height: 140px;
        margin-top: 15px;
        border-radius: 10px;
        margin-left: 48px;
        text-align: left;
    }

    .div2 {
        border: 1px solid black;
        width: 90%;
        height: 100%;
        margin-top: 15px;
        border-radius: 10px;
        margin-bottom: 15px;
        margin-left: 48px;
        text-align: left;

    }

    .div3 {
        border: 1px solid black;
        width: 90%;
        height: 85px;
        margin-top: 15px;
        border-radius: 10px;
        margin-bottom: 30px;
        margin-left: 48px;
        text-align: left;
    } */

    .title {
        margin-top: 10px;
        margin-bottom: 5px;
        font-weight: bold;
        margin-left: 20px;
        font-size: 15px;
    }
</style>
